import React, { useContext, useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import DigitalWallets from '@/components/DigitalWalletsRebrand/DigitalWalletsRebrand';
import Layout from '@/components/layout';
import AdditionalCardsBranded from '@/components/AdditionalCardsRebrand/AdditionalCardsRebrand';
import { PageContext } from '@/context/PageContext';
import HeroBranded from '@/components/HeroBrandedRebrand/HeroBrandedRebrand';
import { ImportantInformation } from '@latitude/important-information-rebrand';
import HeroV2 from '@/components/Hero/HeroV2/HeroV2';
import { PADDING } from '@latitude/core/utils/constants';
import CardFilterListRebrand from '@/components/CardFilterListRebrand/CardFilterListRebrand';
import PageData from '@/data/pages/credit-cards/index.json';
import {
  getAdditionalCardsRebrandDataFromContentful,
  getCardFilterListRebrandDataFromContentful
} from '@/utils/creditCardsContentfulData';

function CreditCardsPage(props) {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */
  const [showSection, setShowSection] = useState(false);

  const additionalCards = {
    heading: 'Looking for your card?',
    items: [
      {
        title: 'CreditLine (applied for at Apple)',
        href: '/credit-cards/apple-creditline/',
        trackId: 'credit-cards--compare-cards--fom--applecreditline',
        imageSrc: require('../../images/credit-cards/creditline-afs-2x.png'),
        productid: ['CCAUAFS']
      },
      {
        title: 'Latitude Infinity<br /> Rewards Visa',
        href: '/credit-cards/latitude-infinity-rewards-credit-card/',
        trackId: 'credit-cards--compare-cards--fom--latitude-infinity',
        imageSrc: require('../../images/credit-cards/latitude-infinity-rewards-visa-card-horizontal.png'),
        productid: ['CCAUINF']
      },
      {
        title: 'Latitude<br /> Mastercard',
        href: '/credit-cards/latitude-mastercard/',
        trackId: 'credit-cards--compare-cards--fom--latitude-mastercard',
        imageSrc: require('../../images/credit-cards/latitude-mastercard.png'),
        productid: ['CCAULMC']
      },
      {
        title: 'Latitude Eco<br /> Mastercard',
        href: '/credit-cards/latitude-eco-mastercard',
        trackId: 'credit-cards--compare-cards--fom--latitude-eco-mastercard',
        imageSrc: require('../../images/credit-cards/latitude-eco-mastercard.png'),
        productid: ['CCAUECO']
      },
      {
        title: 'CreditLine',
        href: '/credit-cards/credit-line/',
        trackId: 'credit-cards--compare-cards--fom--creditline',
        imageSrc: require('../../images/credit-cards/creditline-120x76.webp'),
        productid: ['CCAUCLN']
      },
      {
        title: "Buyer's Edge",
        href: '/credit-cards/buyers-edge/',
        trackId: 'credit-cards--compare-cards--fom--buyers-edge',
        imageSrc: require('../../images/credit-cards/buyers-edge-120x76.webp'),
        productid: ['CCAUBE']
      },
      {
        title: 'CareCredit',
        href: '/credit-cards/care-credit/',
        trackId: 'credit-cards--compare-cards--fom--care-credit',
        imageSrc: require('../../images/credit-cards/care-credit.png'),
        productid: ['CCAUCCD']
      },
      {
        title: 'David Jones Icon credit card',
        href: 'https://www.davidjones.com/credit-card/compare/icon',
        trackId: 'credit-cards--compare-cards--fom--david-jones',
        imageSrc: require('../../images/credit-cards/david-jones.webp'),
        productid: ['CCAUDJ']
      }
    ]
  };

  const brandedCardFilterListData = {
    heading: 'Choose the card that works for you',

    filterOptions: [
      { label: 'All', value: 'all' },
      { label: 'Interest Free', value: 'interest-free-plans' },
      { label: 'Travel', value: 'travel' },
      { label: 'Rewards', value: 'rewards' },
      { label: 'Balance transfer', value: 'balance-transfer' }
    ],

    cards: [
      {
        type: 'Credit cards',
        category: ['all', 'rewards', 'balance-transfer'],
        title: 'Latitude Low Rate Mastercard',
        productid: 'CCAULRM',
        order: { all: 4, rewards: 3, 'balance-transfer': 3  },

        bgImage: {
          url: '/images/credit-cards/lr-bg-card-img.webp',
          name: 'low rate card bg image'
        },

        cardArt: {
          url: '/images/credit-cards/cc-lr.webp',
          name: 'low rate card art'
        },

        fee: {
          value: '$69',
          label: 'credit card fee charged annually'
        },
        rate: {
          value: '13.99%',
          label: 'p.a. purchase rate'
        },
        description: [
          '0% p.a. for 24 months on Balance Transfers. 3% Balance Transfer fee applies. New customers only, must be approved by 31 July 2026. Balance Transfer must be submitted by 30 September 2026. T&Cs apply<sup>*</sup>.',
          'Our lowest rate credit card offer.',
          'Get 3% back in Latitude Rewards14 when you set up recurring payments direct with participating utilities, telco, and streaming services. T&Cs apply.',
          'Unlock offers and discounts from 100s of your favourite merchants.',
          'Up to 55 days interest free* on general purchases.'
        ],
        ctas: [
          {
            text: 'Apply now',
            url: '/credit-cards/low-rate#limited-time-offer-selector',
            variant: 'primary',
            size: 'lg',
            promocode: '',
            btPromoCode: ''
          },
          {
            text: 'Find out more',
            url: '/credit-cards/low-rate',
            variant: 'secondary-blue',
            size: 'lg',
            promocode: '',
            btPromoCode: ''
          }
        ]
      },
      {
        type: 'Credit cards',
        category: ['all', 'travel', 'rewards', 'balance-transfer'],
        title: 'Latitude 28° Global Platinum Mastercard',
        productid: 'CCAU28D',
        order: { all: 3, travel: 1, rewards: 2, 'balance-transfer': 4 },

        bgImage: {
          url: '/images/credit-cards/28d-bg-card-img.webp',
          name: '28d background image'
        },

        cardArt: {
          url: '/images/credit-cards/cc-28d.webp',
          name: '28d credit card'
        },

        fee: {
          value: '$0',
          label: (
            <>
              Annual fee waived for the first year <b>(normally $96)</b>
            </>
          )
        },
        rate: {
          value: '$0',
          label:
            'International transaction or currency conversion fees on purchases'
        },
        description: [
          'Spend $12,000+ annually on eligible purchases to have your fee waived year after year. New customers only<sup>16</sup>.',
          'Shop and be rewarded with up to $240 in Latitude Rewards<sup>17</sup> when you spend $1,000 or more on eligible international and local purchases each month.',
          'Complimentary E-Commerce Protection and Purchase Protection Insurances.',
          'Unmissable every day and travel offers.',
          'Great foreign exchange rates set by Mastercard.'
        ],
        ctas: [
          {
            text: 'Apply now',
            url:
              'https://cards.latitudefinancial.com/28degrees?source_code=ISAAV',
            variant: 'primary',
            size: 'lg',
            promocode: '5Q7MUZC7',
            btPromoCode: 'M9FNRZ2R'
          },
          {
            text: 'Find out more',
            url:
              '/credit-cards/28-degrees/?promo_code=E8Q4CJE6&source_code=IDAAA',
            variant: 'secondary-blue',
            size: 'lg',
            promocode: '',
            btPromoCode: ''
          }
        ]
      },

      {
        type: 'Credit cards',
        category: ['all', 'interest-free-plans', 'balance-transfer'],
        title: 'Latitude GO Mastercard',
        productid: 'CCAUGOM',
        order: { all: 2, 'interest-free-plans': 2, 'balance-transfer': 1 },

        bgImage: {
          url: '/images/credit-cards/go-bg-card-img.webp',
          name: 'gomc background image'
        },

        cardArt: {
          url: '/images/credit-cards/cc-go.webp',
          name: 'gomc credit card'
        },

        fee: {
          value: '$11.95',
          label: 'Monthly credit card fee'
        },
        rate: {
          value: '0%',
          label: (
            <>
              Interest on $250+ purchases for 6 months - opt in<sup>3</sup>
            </>
          )
        },
        description: [
          'Get your first 6 months card fee credited back to you when you make any purchase within the first 3 months from approval & get $250 credit back when you spend $2,000 per month for your first 3 months from approval on general or Interest Free purchases with your Latitude GO Mastercard credit card.',
          '60 months Interest Free plan at Harvey Norman plus bonus Harvey Norman gift card up to $1,000 with your Latitude GO Mastercard credit card when you spend a minimum of $1,000 on an equal monthly payment plan',
          'Enjoy 6 months Interest Free on your general purchases of $250 or more. Select your purchases in the Latitude App within 30 days.<sup>3</sup>',
          'Long term Interest Free Plans at Harvey Norman and other fantastic retailers<sup>1</sup>.',
          '0% p.a. for 26 months on Balance Transfers. 3% Balance Transfer fee and eligibility criteria apply. New customers only, must be approved by 26 February 2027. Balance Transfer must be submitted by 31 March 2027. T&Cs apply*.'
        ],
        ctas: [
          {
            text: 'Apply now',
            url: 'https://cards.latitudefinancial.com/go?source_code=IDAAA',
            variant: 'primary',
            size: 'lg',
            promocode: 'TSWLDQJR',
            btPromoCode: 'P3VEDHGC'
          },
          {
            text: 'Find out more',
            url: '/credit-cards/gomastercard/',
            variant: 'secondary-blue',
            size: 'lg',
            promocode: '',
            btPromoCode: ''
          }
        ]
      },
      {
        type: 'Credit cards',
        category: ['all', 'rewards', 'interest-free-plans', 'balance-transfer'],
        title: 'Latitude Gem Visa',
        productid: 'CCAUGEM',
        order: {
          all: 1,
          rewards: 1,
          'interest-free-plans': 1,
          'balance-transfer': 2
        },

        bgImage: {
          url: '/images/credit-cards/gem-bg-card-img.webp',
          name: 'gem background image'
        },

        cardArt: {
          url: '/images/credit-cards/cc-gem.webp',
          name: 'gem credit card'
        },

        fee: {
          value: '$11.95',
          label: 'Monthly credit card fee'
        },
        rate: {
          value: '0%',
          label: (
            <>
              Interest on $250+ purchases for 6 months - opt in<sup>3</sup>
            </>
          )
        },
        description: [
          '0% p.a. for 26 months on Balance Transfers. 3% Balance Transfer fee and eligibility criteria apply. New customers only, must be approved by 26 February 2027. Balance Transfer must be submitted by 31 March 2027. T&Cs apply<sup>*</sup>.',
          '0% Interest long term payment plans.<sup>3</sup>',
          'Up to 55 days<sup>2</sup> interest free on general purchases.',
          'Amazing everyday and travel offers.'
        ],
        ctas: [
          {
            text: 'Apply now',
            url: 'https://cards.latitudefinancial.com/gem?source_code=IDAAA',
            variant: 'primary',
            size: 'lg',
            promocode: 'XQUYWJW4',
            btPromoCode: 'XQUYWJW4'
          },
          {
            text: 'Find out more',
            url: '/credit-cards/gem-visa/',
            variant: 'secondary-blue',
            size: 'lg',
            promocode: '',
            btPromoCode: ''
          }
        ]
      },
      {
        type: 'Credit cards',
        category: ['all', 'rewards', 'balance-transfer'],
        title: 'David Jones credit cards',
        productid: 'CCAUDJ',
        subheading:
          'Access to unrivalled services, exclusive benefits and iconic experiences like no other; unlocked while you shop.',
        order: { all: 5, rewards: 4, 'balance-transfer': 5 },
        bgImage: {
          url: '/images/credit-cards/dj-bg-card-img.webp',
          name: 'dj background image'
        },

        cardArt: {
          url: '/images/credit-cards/cc-dj.webp',
          name: 'dj credit card'
        },

        description: [
          'Earn David Jones Points every time you shop<sup>6</sup>',
          'Use your points to purchase your favourite items at David Jones, redeem for gift cards and more<sup>7</sup>',
          'Gain access to exclusive benefits such as VIP sales and previews<sup>8</sup>, complimentary express delivery<sup>9</sup> and gift wrapping<sup>10</sup> at David Jones '
        ],
        ctas: [
          {
            text: 'Find out more at David Jones',
            url: 'https://www.davidjones.com/credit-card',
            variant: 'secondary-blue',
            size: 'lg',
            promocode: '',
            btPromoCode: ''
          }
        ]
      }
    ]
  };

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.location.hash === '#interest-free-plans'
    ) {
      setShowSection(true);
    }
  }, []);

   const cardFilterListData =
    getCardFilterListRebrandDataFromContentful(
      state?.cardFilterListRebrandData?.[0]
    ) || brandedCardFilterListData;
  const additionalCardsData =
    getAdditionalCardsRebrandDataFromContentful(
      state?.additionalCardsRebrandData?.[0]
    ) || additionalCards;

  return (
    <Layout location={props.location}>
      <main
        css={`
          overflow-x: hidden;
        `}
      >
        <Helmet>
          <link
            rel="canonical"
            href="https://www.latitudefinancial.com.au/credit-cards/"
          />
          <title>
            Explore Flexible Credit Card Options | Apply With Latitude
          </title>
          <meta
            name="description"
            content="Discover Latitude's range of credit cards tailored to suit your lifestyle. From rewards to low fees, find the card that fits your needs today!"
          />
        </Helmet>
        {/* <HeroV1 {...hero} /> */}
        <div
          css={`
            img[src*='lrmc-awards-overlay.webp'] {
              @media (min-width: 768px) {
                width: 250px !important;
              }
              @media (max-width: 767px) {
                display: none;
              }
            }
          `}
        >
          <HeroV2
            {...(state?.heroBannerData?.[0] || PageData?.heroBannerData?.[0])}
          />
        </div>
        <div id="credit-card-filter-list">
          <CardFilterListRebrand {...cardFilterListData} />
        </div>
        <AdditionalCardsBranded {...additionalCardsData} />
        <DigitalWallets
          heading="Digital wallets"
          subheading="You can pay any way on your phone or wearable tech device with just a tap."
        />
        <HeroBranded heading={<>Download the Latitude credit card app</>} />
        <ImportantInformation
          css={`
            .row {
              @media (min-width: 1600px) {
                padding-left: ${PADDING.P32};
                padding-right: ${PADDING.P32};
              }
            }
          `}
          data={require('../../data/pages/credit-cards/index.json')}
          {...{
            ...state?.importantInfoData?.[0],
            sectionOneColummClasses: 'col-12 col-lg-6',
            sectionTwoColummClasses: 'col-12 col-lg-6'
          }}
        />
      </main>
    </Layout>
  );
}

export default CreditCardsPage;
